import { guessRegionFromTimezone } from '@/helpers/guessRegionFromTimezone';
import { type Region } from '@heidi/schema/ml-scribe';

/**
 * Fallback region for pre-auth anonymous dictation when no authenticated region
 * signal exists (kinde, JWT, hostname, etc.).
 *
 * Returns the timezone guess so {@link getTranscriptionBaseUrl} can route
 * anonymously. Matches the kinde-properties retry fallback in `scribeAPI.ts`.
 *
 * ⚠️ Best-effort UX routing only (APP-6111 C10): browser timezone is
 * spoofable, unmapped zones default to AU, and this must not gate
 * compliance-sensitive decisions.
 */
export function resolveAnonymousTranscriptionFallbackRegion(): Region | undefined {
  return guessRegionFromTimezone();
}
